import './css/index.css';
import 'components/breadcrumbs';
import 'components/card-rte-text';
import 'components/card-rte-image';
import 'components/detail-body';
import 'components/group-cards-data';
import 'components/data-release-listing';
import 'components/data-release-archive-filter';
import 'components/footer';
import 'components/notification';

// import last
import 'components/snippets/callouts';
import 'components/snippets/images';
import 'components/snippets/footnotes';

import DataReleaseArchiveFilter from 'components/data-release-archive-filter';
import Mediator from 'js/mediator';
import Navigation from 'components/navigation';


Mediator.create( {

    componentClasses: [
        Navigation,
        DataReleaseArchiveFilter

    ],

    init() {

        console.info( 'The Data Archive Page has initiated.' );

    },

    ready() {

        console.info( 'The Data Archive Page is ready.' );

        console.info( 'Components:', this.components );

    }

} );
